import { getSetup } from '@manager/api/services/setup-service';
import { useQuery } from '@tanstack/vue-query';

export function useSetupQuery() {
  return useQuery({
    queryKey: ['setup'],
    queryFn: () => getSetup(),
  });
}
